<template>
    <div v-if="isMounted" class="unlayer-email-process-modal" data-qa="unlayer-email-process-modal">
        <div>
            <CampaignUnlayerBuilderModal
                ref="campaignUnlayerBuilderModal"
                data-qa="unlayer-email-modal"
                :marketing-email-id="getMarketingEmailId()"
                :funnel-id="getFunnelId()"
                :title="cell.value && cell.value.name ? cell.value.name : coreConfig.templateTitleStr"
                :unlayer-project-id="coreConfig.unlayerProjectId"
                :app-id="coreConfig.appId"
                :user-id="coreConfig.userId"
                :booking-link-hostname="coreConfig.bookingLinkHostname"
                :environment="coreConfig.environment"
                :campaign-email-preview-enabled="coreConfig.campaignEmailPreviewEnabled"
                :unlayer-ai-tools-enabled="coreConfig.unlayerAiToolsEnabled"
                :unlayer-smart-merge-tags-enabled="coreConfig.unlayerSmartMergeTagsEnabled"
                :show-verified-domains-new-keys-only-enabled="coreConfig.showVerifiedDomainsNewKeysOnlyEnabled"
                :unlayer-builder-version-override="coreConfig.unlayerBuilderVersionOverride"
                :use-unlayer-builder-version-override-enabled="coreConfig.useUnlayerBuilderVersionOverrideEnabled"
                :unlayer-email-logo-tool-enabled="coreConfig.unlayerEmailLogoToolEnabled"
                :wrap-sender-display-name-with-quotes-enabled="coreConfig.wrapSenderDisplayNameWithQuotesEnabled"
                :merge-fields-in-from-address-enabled="coreConfig.mergeFieldsInFromAddressEnabled"
                :contact-search-in-test-emails-enabled="coreConfig.contactSearchInTestEmailsEnabled"
                :liquid-merge-fields-in-automations-enabled="coreConfig.liquidMergeFieldsInAutomationsEnabled"
                :is-cell-ready="isCellReady"
                :auto-open-content="autoOpenContent"
                is-konva
                @closeCampaignUnlayerEmailBuilderModal="handleClose"
                @campaignUnlayerEmailNotReady="handleMarkDraft"
                @campaignUnlayerEmailReady="handleMarkReady"
            />
        </div>
    </div>
</template>

<script>
import CampaignUnlayerBuilderModal from '@/components/unlayer/CampaignUnlayerBuilderModal.vue';
import { loadCoreConfigs, loadTemplate } from './unlayer.email.api';

import sentry from '@/analytics/sentry';


export default {
    components: {
        CampaignUnlayerBuilderModal,
    },


    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    marketingEmailId: null,
                },
            }),
        },
        funnelId: {
            type: Number,
            default: 0,
        },
        autoOpenContent: Boolean,
    },

    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            isMounted: false,
            coreConfig: {},
            marketingEmailId: null,
        };
    },

    computed: {
        isCellReady() {
            return this.cell.value?.ready === '1';
        },
    },

    async mounted() {
        await this.loadTemplate();
    },

    methods: {
        async loadTemplate() {
            try {
                const cell = { ...this.cell };

                cell.value = cell.value || {};

                if (!cell.value.marketingEmailId) {
                    const emailLabel = cell.value?.name ?? this.$t('funnel.unlayer.email.title');

                    this.marketingEmailId = await loadTemplate(emailLabel);
                    this.coreConfig = await loadCoreConfigs(this.marketingEmailId);
                    this.isMounted = true;
                } else {
                    this.marketingEmailId = cell.value.marketingEmailId;
                    this.coreConfig = await loadCoreConfigs(cell.value.marketingEmailId.toString().replace('L', ''));
                    this.isMounted = true;
                }
            } catch (error) {
                sentry.captureException(error);
            }
        },
        handleClose() {
            this.$emit('close-modal');
        },
        handleMarkReady() {
            this.saveCell(true);
        },
        handleMarkDraft() {
            this.saveCell(false);
        },
        getMarketingEmailId() {
            return `${this.marketingEmailId}`;
        },
        getFunnelId() {
            return `${this.funnelId}`;
        },
        getCurrentLabel() {
            return this.$t(`funnel.edit.label.flow.${this.cell.meta.style}`);
        },
        saveCell(isReady) {
            const cell = { ...this.cell };

            cell.value = cell.value || {};
            cell.value.marketingEmailId = this.marketingEmailId;

            this.$emit('update-cell-value', { cell, isReady, preventClose: true });
        },
    },
};
</script>
